module.exports = __webpack_public_path__ + "img/zhifufangshi.f3020cc5.png";